export enum DESKTOP_FONT_SIZE {
  h1 = 2,
  h2 = 1.75,
  h3 = 1.5,
  h4 = 1.25,
  h5 = 1.125,
  h6 = 1,
  subtitle1 = 0.875,
  body1 = 1,
  body2 = 0.875,
  button = 0.875,
  caption = 0.875,
  overline = 0.75,
}
